<script setup lang="ts">
// types
import type { StrapiFooter } from '@ts-strapi/interfaces'
// components
import FooterMobile from '@Widgets/Footers/FooterMobile.vue'
import FooterDesktop from '@Widgets/Footers/FooterDesktop.vue'

defineOptions({
  name: 'FooterRoot',
})

defineProps<{
  data: StrapiFooter
}>()
</script>

<template>
  <FooterMobile :data="data" />
  <FooterDesktop :data="data" />
</template>